import { render, staticRenderFns } from "./SuppliesDocuments.vue?vue&type=template&id=27ccbee6&"
import script from "./SuppliesDocuments.vue?vue&type=script&lang=ts&"
export * from "./SuppliesDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports